module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("THE SAMSON SYNDROME ")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "p0011-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#aa_00",
      "id": "bb_00"
    }
  }, [_c('b', [_vm._v("INTRODUCTION")])]), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0011-02-1"
    }
  }, [_vm._v("PEOPLE HAVE ALWAYS BEEN FASCINATED BY DARING adventurers who live on the edge. How else do you explain the phenomenal success of James Bond 007? Ian Fleming’s British superspy is the hero of over twenty films that have earned over a billion dollars worldwide. Every Bond film features dangerous villains, exotic weaponry, ingenious gadgets, fast cars, and even faster women. But it’s all in a day’s work for the coolest secret agent of them all, who, at last count, has saved the world twenty-three times and has yet to get his hair messed up.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-03-3"
    }
  }, [_vm._v("This book is about a man in the Bible who was so Bondlike in his attitude and lifestyle that one wonders if he might have been part of Ian Fleming’s inspiration. Samson, whose story is told in four chapters of the book of Judges, was young, strong, good-looking, cocky, courageous, and an incorrigible ladies man. He had a nose for trouble, a knack for hair-raising escapes, and more girlfriends than Radio City has Rockettes. If Samson were alive today he’d be a superstar athlete or an action-movie star. Or "), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("he’d be a Navy SEAL or a world-champion prize fighter. He’d be on the cover of "), _c('i', [_vm._v("GQ")]), _vm._v(" or "), _c('i', [_vm._v("Sports Illustrated.")]), _vm._v(" He’d be surrounded by popping flashbulbs and adoring groupies.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-2"
    }
  }, [_vm._v("But he’d still be a disappointment to God.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-3"
    }
  }, [_vm._v("You see, while Samson was easily the strongest man in the Bible, he was also, in many ways, the weakest. He was handpicked by a gracious God to lead his people, the Israelites, in a revolt against the dreaded Philistines, who had been oppressing them without resistance for forty years. And talk about gifts! No one in Scripture could match Samson for sheer talent and potential. But rather than developing into a thrilling saga of faith and patriotism, Samson’s story degenerates quickly into a tawdry soap opera. Oh yes, there are flashes of greatness, brief moments when we catch little glimpses of the hero God intended for him to be. But for the most part, Samson was a selfish, shallow-minded playboy who squandered his talents.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-4"
    }
  }, [_vm._v("Perhaps this is why Samson is largely ignored in print. Very few books about him exist. To most Christians he is merely “the guy who fooled around with Delilah” or “that strong dude with the long hair.” We apparently think he has little to say to the modern believer. We prefer instead to focus our attention on more positive, politically correct characters and expound endlessly on their “secrets of success.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-5"
    }
  }, [_vm._v("But let me ask you a question.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-6"
    }
  }, [_vm._v("Would God have devoted a whopping four chapters (ninety-six verses) of His precious Word to Samson’s story if it "), _c('i', [_vm._v("didn’t")]), _vm._v(" contain a powerful message for His people?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-7"
    }
  }, [_vm._v("Of course not.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("That’s why I think it’s high time we rediscovered Samson. I believe this Bible bad boy has been trying to tell us something for ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("years. Something important. And I believe his message is needed now more than ever.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "h1",
    attrs: {
      "id": "p0013-02-2"
    }
  }, [_c('b', [_vm._v("SAMSON’S MESSAGE")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0013-03-3"
    }
  }, [_vm._v("Very simply, I believe Samson teaches us why strong men fail.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-04-5"
    }
  }, [_vm._v("Think about it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-04-6"
    }
  }, [_vm._v("Strong, talented, godly men should be the pillars of our homes, churches, and communities. But too often they aren’t. The pages of history are filled with heartbreaking stories of strong, godly men who disgraced themselves by falling into sin. For example, King David of Israel, the mighty warrior and man after God’s own heart, wandered through a year-long period of darkness in which he stole another man’s wife and orchestrated a murder plot that had enough intrigue to fill an Alfred Hitchcock double feature. And what about all the fallen heroes in our day? Off the top of your head, you could probably name at least a half-dozen strong men of good reputation who have suffered moral failure and public disgrace. From professional athletes to entertainers to business executives to clergymen, we’re constantly hearing the gory details of how a good boy turned bad.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-04-9"
    }
  }, [_vm._v("But it’s not just celebrities and public figures who stumble. It’s us too. The guys who may not be famous, but nonetheless are raising the children, leading the churches, and running the businesses of America.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-04-11"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("I believe "), _c('i', [_vm._v("all")]), _vm._v(" men stand to benefit from Samson’s message, even those who may not at this moment be teetering on the edge of some great moral abyss. I also believe that the women who love strong men can gain some valuable insights from Samson’s experiences. After all, much of the biblical narrative focuses on ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("his relationships and interactions with females. There is no character in the Bible that offers a woman keener insights into the male psyche.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-2"
    }
  }, [_vm._v("However, there is a certain type of man who should find Samson’s message especially helpful.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-3"
    }
  }, [_vm._v("Perhaps, like Samson, you’ve been richly blessed and gifted by God. You sense his call on your life and you know he has important work for you to do. You’ve got a responsible job and people look up to you. You’ve got a great wife and beautiful kids and you’ve already tasted enough success to know the sky’s the limit. But something is wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-4"
    }
  }, [_vm._v("Your friends don’t see it. Even your wife might be overlooking the subtle signs. But it’s happening. You can feel yourself drifting. For some reason, you’re just not as passionate about the things of God as you used to be. And your marriage, though it isn’t all that bad, doesn’t satisfy you the way it used to. Perhaps at times you even feel drawn to things that you know should be off limits for a person of faith. Maybe you’ve even begun to dabble in some of those things (secretly, of course) and can feel the grip of sin tightening on your life. You couldn’t begin to explain why you’re in trouble, you just know you are. And now you’re wondering—and are perhaps terrified of where it will all end.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-5"
    }
  }, [_vm._v("Well, friend, it’s to you that Samson speaks the loudest.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "p0014-03-7"
    }
  }, [_c('b', [_vm._v("THE SAMSON SYNDROME")])])]), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0014-04-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("After almost thirty years in the preaching ministry, and with much of that time spent working closely with strong men of faith, I have come to believe in what I call "), _c('i', [_vm._v("The Samson Syndrome. The Samson Syndrome")]), _vm._v(" is a set of twelve tendencies revealed in the ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("biblical account of Samson’s life that clearly contributed to his erratic behavior, his spiritual decline, and ultimately, his failure as a deliverer of God’s people. These tendencies are common to men of strength in every generation. They represent the unique challenges that strong men will always face. A man may have to contend with one of them or all twelve, but no man will totally escape their influence. Simply put, these tendencies are the reasons why strong men fail.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-02-2"
    }
  }, [_vm._v("What I’ll do in this book is explain each tendency and show why it is often a problem for strong men. Then I’ll offer some specific, positive suggestions on how you can overcome it. I’ll warn you now that this book will take us into some dark territory. Samson’s trail will lead us to some topics that aren’t often discussed around the dinner table. But we’ll view them all through the lens of Scripture, we’ll lighten up and have a few laughs along the way, and in the end, I believe we’ll all be better equipped to stand firm in our faith, to fulfill our God-given potential, and even to exceed our loftiest aspirations.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-02-3"
    }
  }, [_vm._v("So I invite you to keep reading and join me on a fascinating journey back to a time of danger and intrigue. Let’s walk the dusty roads of Israel. Let’s step into the teeming marketplaces and onto the bloody battlefields of that ancient, mysterious land. Let’s listen in on the secret conversations of deadly enemies and the pillow talk of illicit lovers. Let’s witness the weakness of man in all its shame and the power of God in all its glory. And through it all, let’s learn how to be faithful and to live with honor before God so that we might never have to stand before Him and explain why we didn’t accomplish the things He called us to do. ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbe32110","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter3.vue
// module id = 75
// module chunks = 0